import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { scrollToPosition } from "../../../utils/utility";
import { useForm, Controller } from "react-hook-form";
import { Add, ArrowDown2, Minus } from "iconsax-react";
import BaseTextField from "../../common/base-text-field/base-text-field";
import { BaseButton } from "../../common/base-button/base-button";
import { useTranslation } from "react-i18next";
import axios from "axios";
import BASE_URL from "../../../constants/baseUrls";
import { toast } from "react-toastify";
import { IS_MOBILE } from "../../../constants/breakpoints";

import winterTour1 from "../../../assets/imgs/tour/winter/1.jpg";
import winterTour2 from "../../../assets/imgs/tour/winter/2.jpg";
import winterTour3 from "../../../assets/imgs/tour/winter/3.png";
import winterTour4 from "../../../assets/imgs/tour/winter/4.jpg";
import winterTour5 from "../../../assets/imgs/tour/winter/5.jpg";
import winterTour6 from "../../../assets/imgs/tour/winter/6.jpg";
import winterTour7 from "../../../assets/imgs/tour/winter/7.jpg";
import winterTour8 from "../../../assets/imgs/tour/winter/8.jpg";
import winterTour9 from "../../../assets/imgs/tour/winter/9.jpg";
import winterTour10 from "../../../assets/imgs/tour/winter/10.jpg";
import winterTour11 from "../../../assets/imgs/tour/winter/11.jpg";
import winterTour12 from "../../../assets/imgs/tour/winter/12.jpg";
import winterTour13 from "../../../assets/imgs/tour/winter/13.jpg";
import springTour1 from "../../../assets/imgs/tour/spring/1.jpg";
import springTour2 from "../../../assets/imgs/tour/spring/2.jpg";
import springTour3 from "../../../assets/imgs/tour/spring/3.jpg";
import springTour4 from "../../../assets/imgs/tour/spring/4.jpg";
import springTour5 from "../../../assets/imgs/tour/spring/5.jpg";
import springTour6 from "../../../assets/imgs/tour/spring/6.jpg";
import springTour7 from "../../../assets/imgs/tour/spring/7.jpg";
import springTour8 from "../../../assets/imgs/tour/spring/8.jpg";
import springTour9 from "../../../assets/imgs/tour/spring/9.jpg";
import springTour10 from "../../../assets/imgs/tour/spring/10.jpg";
import springTour11 from "../../../assets/imgs/tour/spring/11.jpg";
import springTour12 from "../../../assets/imgs/tour/spring/12.jpg";

export default function CountryTourDetail() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const accessToken = localStorage.getItem("accessToken");

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            mobile_phone: "",
            email: "",
            adult_count: 1,
            child_count: 0,
        },
    });

    const winterTour = [
        { id: 1, image: winterTour1 },
        { id: 2, image: winterTour2 },
        { id: 3, image: winterTour3 },
        { id: 4, image: winterTour4 },
        { id: 5, image: winterTour5 },
        { id: 6, image: winterTour6 },
        { id: 7, image: winterTour7 },
        { id: 8, image: winterTour8 },
        { id: 9, image: winterTour9 },
        { id: 10, image: winterTour10 },
        { id: 11, image: winterTour11 },
        { id: 12, image: winterTour12 },
        { id: 13, image: winterTour13 },
    ];
    const springTour = [
        { id: 1, image: springTour1 },
        { id: 2, image: springTour2 },
        { id: 3, image: springTour3 },
        { id: 4, image: springTour4 },
        { id: 5, image: springTour5 },
        { id: 6, image: springTour6 },
        { id: 7, image: springTour7 },
        { id: 8, image: springTour8 },
        { id: 9, image: springTour9 },
        { id: 10, image: springTour10 },
        { id: 11, image: springTour11 },
        { id: 12, image: springTour12 },
    ];
    const tourName = searchParams.get("tour");
    const tourImages = tourName === "winter" ? winterTour : tourName === "spring" ? springTour : [];

    useEffect(() => {
        scrollToPosition(0, 0);
    }, []);

    const [isLoading, setIsLoading] = useState(false);
    const handleReservation = async data => {
        console.log(data);
        // event.preventDefault();
        try {
            setIsLoading(true);
            const response = await axios.post(
                `${BASE_URL}/api/v2/itinerary/country-tour/request/`,
                {
                    tour_name: tourName === "winter" ? "iran_winter_2027" : "iran_spring_2027",
                    ...data,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                },
            );
            toast.success(response?.data?.message || t("successMessage"), { toastId: "custom-id-yes" });
        } catch (error) {
            toast.error(t("errorMessage"), { toastId: "custom-id-yes" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: "20px" }}>
            <Grid container justifyContent="space-between" alignItems="stretch" spacing={2}>
                <Grid item md={4} xs={12}>
                    {IS_MOBILE ? (
                        <Accordion>
                            <AccordionSummary expandIcon={<ArrowDown2 />} aria-controls={`${1}-panel1-content`} id={`${1}-panel1-header`}>
                                <Typography fontWeight={700}>{t("tourRequestForm")}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TourForm
                                    onSubmit={handleSubmit(handleReservation)}
                                    control={control}
                                    register={register}
                                    errors={errors}
                                    isLoading={isLoading}
                                />
                            </AccordionDetails>
                        </Accordion>
                    ) : (
                        <Paper
                            elevation={0}
                            sx={{
                                width: "100%",
                                p: 3,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 3,
                                position: "sticky",
                                top: 100,
                                alignSelf: "flex-start",
                            }}
                        >
                            <TourForm
                                onSubmit={handleSubmit(handleReservation)}
                                control={control}
                                register={register}
                                errors={errors}
                                isLoading={isLoading}
                            />
                        </Paper>
                    )}
                </Grid>
                <Grid item md={7.5} xs={12}>
                    {tourImages?.map(spring => {
                        return <img key={spring.id} width="100%" src={spring.image} alt={`Tour ${spring.id}`} />;
                    })}
                </Grid>
            </Grid>
        </Container>
    );
}

export function TourForm({ onSubmit, control, register, errors, isLoading }) {
    const { t } = useTranslation();
    return (
        <Stack spacing={2.5} component="form" onSubmit={onSubmit}>
            {!IS_MOBILE && <Typography fontWeight={700}>{t("tourRequestForm")}</Typography>}

            <BaseTextField
                dir="ltr"
                type="text"
                label={t("firstName")}
                name="first_name"
                placeholder="Ali"
                register={{
                    ...register("first_name", {
                        required: t("firstNameRequired"),
                    }),
                }}
                error={errors.first_name?.message}
                helperText={errors.first_name?.message}
                size="small"
                radius="10px"
            />
            <BaseTextField
                dir="ltr"
                type="text"
                label={t("lastName")}
                name="last_name"
                placeholder="Ali"
                register={{
                    ...register("last_name", {
                        required: t("lastNameRequired"),
                    }),
                }}
                error={errors.last_name?.message}
                helperText={errors.last_name?.message}
                size="small"
                radius="10px"
            />

            {/* Mobile */}
            <BaseTextField
                dir="ltr"
                type="number"
                label={t("phoneNumber")}
                name="mobile_phone"
                placeholder="09123456789"
                register={{
                    ...register("mobile_phone", {
                        required: t("phoneNumberValidation4"),
                    }),
                }}
                error={errors.mobile_phone?.message}
                helperText={errors.mobile_phone?.message}
                size="small"
                radius="10px"
            />

            {/* Email */}

            <BaseTextField
                dir="ltr"
                type="text"
                label={t("email")}
                name="email"
                placeholder="example@email.com"
                register={{
                    ...register("email", {
                        required: t("emailNotValid"),
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: `${t("phoneNumber")} ${t("isWrong")}`,
                        },
                    }),
                }}
                error={errors.email?.message}
                size="small"
                radius="10px"
            />

            {/* Passengers */}
            {[
                {
                    name: "adult_count",
                    label: t("adult"),
                    description: t("ageGroup1"),
                    min: 1,
                },
                {
                    name: "child_count",
                    label: t("child"),
                    description: t("ageGroup4"),
                    min: 0,
                },
            ].map(item => (
                <Controller
                    key={item.name}
                    name={item.name}
                    control={control}
                    rules={{
                        min: {
                            value: item.min,
                            message: "تعداد انتخاب شده معتبر نیست",
                        },
                    }}
                    render={({ field }) => (
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight={600}>{item.label}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {item.description}
                                </Typography>
                            </Box>

                            <Stack direction="row" alignItems="center" spacing={1.5}>
                                <IconButton size="small" disabled={field.value <= item.min} onClick={() => field.onChange(field.value - 1)}>
                                    <Minus size={18} />
                                </IconButton>

                                <Typography fontWeight={700}>{field.value}</Typography>

                                <IconButton size="small" onClick={() => field.onChange(field.value + 1)}>
                                    <Add size={18} />
                                </IconButton>
                            </Stack>
                        </Stack>
                    )}
                />
            ))}

            <BaseButton text={t("submitInformation")} size="large" radius="radius-10" color="primary" type="submit" loading={isLoading} />
        </Stack>
    );
}
